import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "../../lib/api";
import { Card, Spinner } from "../../components/ui-kit";
import DailyReportText from "../../components/DailyReportText";

// Report serale dei registri (modulo "Notifiche automatiche giornaliere"):
// si apre toccando la notifica, mostra il testo completo inviato anche via email.
export default function ReportGiornaliero() {
  const { notificationId } = useParams();
  const [item, setItem] = useState(undefined);
  useEffect(() => {
    api.get("/app/notifications")
      .then(({ data }) => {
        const found = (data.items || []).find((entry) => entry.id === notificationId) || null;
        setItem(found);
        if (found && !found.read) api.patch(`/app/notifications/${found.id}/read`).catch(() => {});
      })
      .catch(() => setItem(null));
  }, [notificationId]);

  return (
    <div className="mx-auto max-w-3xl space-y-4">
      <Link to="/app/controlli" className="inline-flex min-h-[44px] items-center gap-2 text-sm font-medium text-navy hover:underline"><ArrowLeft className="h-4 w-4" /> Controlli di oggi</Link>
      {item === undefined ? <Spinner /> : !item?.detail ? (
        <Card className="p-6 text-sm text-slate-500">Report non disponibile: potrebbe essere stato inviato a un altro utente o non essere più conservato.</Card>
      ) : (
        <Card className="p-5 sm:p-6"><DailyReportText body={item.detail} /></Card>
      )}
    </div>
  );
}
